import { render, staticRenderFns } from "./AssignUser.vue?vue&type=template&id=c8474728&scoped=true"
import script from "./AssignUser.vue?vue&type=script&lang=js"
export * from "./AssignUser.vue?vue&type=script&lang=js"
import style0 from "./AssignUser.vue?vue&type=style&index=0&id=c8474728&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8474728",
  null
  
)

export default component.exports